import React from 'react';
import {
  FieldValues,
  Path,
  useController,
  useFormContext,
} from 'react-hook-form';
import FieldError from './FieldError';
import FieldLabel from './FieldLabel';
import FieldDescribe from './FieldDescribe';
import Time from '../../../app/manage-test-kits/components/questionare/Time';

type ControlledTimePickerProps<TFormValues extends FieldValues> = {
  name: Path<TFormValues>;
  label?: string | React.ReactNode;
  describe?: React.ReactNode;
  callback?: () => void;
  isRequired?: boolean;
  minTime?: string;
  maxTime?: string;
  testID?: string;
  disabled?: boolean;
};

const FormTimePicker = <TFormValues extends FieldValues>({
  name,
  label,
  describe,
  isRequired,
  minTime,
  maxTime,
  testID,
  disabled = false,
  callback = () => ({}),
}: ControlledTimePickerProps<TFormValues>) => {
  const { control } = useFormContext<TFormValues>();
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    rules: isRequired ? { required: 'Required' } : undefined,
  });

  return (
    <div
      id={name}
      className="flex w-full relative min-h-[64px] flex-col gap-0.5"
    >
      {label && (
        <FieldLabel name={name} label={label} isRequired={isRequired} />
      )}
      <div className="w-full bg-white rounded-5">
        <Time
          hasError={!!error}
          minTime={minTime}
          maxTime={maxTime}
          testID={testID}
          defaultValue={(field.value as string) ?? ''}
          handleTimeChange={(val) => {
            field.onChange(val);
            callback();
          }}
          disabled={disabled}
        />
      </div>
      {error && (
        <FieldError className="absolute whitespace-nowrap bottom-0">
          {error.message as string}
        </FieldError>
      )}
      {!error && describe && <FieldDescribe>{describe}</FieldDescribe>}
    </div>
  );
};

export default FormTimePicker;
